import CategoryScreenConnector from './CategoryScreenConnector';

export default CategoryScreenConnector;
